import { floatToCurrency } from "../validate"

function setCursorPosition(element, position) {
  window.requestAnimationFrame(() => {
    element.selectionStart = position
    element.selectionEnd = position
  })
}

export function controlInputCurrency(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let newValue = currentValue.replace(/\D/g, "")
  let prevValueFormated = floatToCurrency(prevValue).replace(/\D/g, "")

  let prevValueString = String(prevValue)
  if (prevValueString.includes(".")) {
    let cents = prevValueString.split(".")[1]
    if (cents.length < 2) {
      prevValueString = prevValueString + "0"
    }

    prevValueString = prevValueString.slice(0, -3)
  }

  let newValueWithoutCents = String(Number(newValue) / 100)
  if (newValueWithoutCents.includes(".")) {
    let cents = newValueWithoutCents.split(".")[1]
    if (cents.length < 2) {
      newValueWithoutCents = newValueWithoutCents + "0"
    }

    newValueWithoutCents = newValueWithoutCents.slice(0, -3)
  }

  let isErase = prevValueFormated.length > newValue.length
  if (newValueWithoutCents !== "0") {
    if (prevValueString.length % 3 === 0 && !isErase) {
      setCursorPosition(element, caret + 1)
    } else if (newValueWithoutCents.length % 3 === 0 && isErase) {
      setCursorPosition(element, caret - 1)
    } else {
      setCursorPosition(element, caret)
    }
  }
}

export function controlInputDate(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  if (currentValue === undefined) {
    currentValue = ""
  }

  if (prevValue === undefined) {
    prevValue = ""
  }

  let currentValueFormated = currentValue.replace(/\D/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/\D/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength

  if ((currentValueLength === 3 || currentValueLength === 5) && !isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  if ((currentValueLength === 2 || currentValueLength === 4) && isErase) {
    setCursorPosition(element, caret - 1)
    return
  }

  setCursorPosition(element, caret)
}

export function controlPhoneInput(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let currentValueFormated = currentValue.replace(/\D/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/\D/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength

  if ((currentValueLength === 1 || currentValueLength === 7) && !isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  if (currentValueLength === 3 && !isErase) {
    setCursorPosition(element, caret + 2)
    return
  }

  if (currentValueLength >= 3 && (caret === 1 || caret === 2) && isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  if (currentValueLength <= 10 && caret === 10 && isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  setCursorPosition(element, caret)
}

export function controlCpfInput(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let currentValueFormated = currentValue.replace(/\D/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/\D/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength

  if ((caret === 4 || caret === 8 || caret === 12) && !isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  setCursorPosition(element, caret)
}

export function controlCnpjInput(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let currentValueFormated = currentValue.replace(/\D/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/\D/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength

  if (
    (caret === 3 || caret === 7 || caret === 11 || caret === 16) &&
    !isErase
  ) {
    setCursorPosition(element, caret + 1)
    return
  }

  setCursorPosition(element, caret)
}

export function controlCnpjAlphanumericInput(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let currentValueFormated = currentValue.replace(/[^a-zA-Z0-9]/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/[^a-zA-Z0-9]/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength

  if (
    (caret === 3 || caret === 7 || caret === 11 || caret === 16) &&
    !isErase
  ) {
    setCursorPosition(element, caret + 1)
    return
  }

  setCursorPosition(element, caret)
}

export function controlZipCodeInput(prevValue, currentValue, evt) {
  const caret = evt.target.selectionStart
  const element = evt.target

  let currentValueFormated = currentValue.replace(/\D/g, "")
  let currentValueLength = currentValueFormated.length
  let prevValueFormated = prevValue.replace(/\D/g, "")
  let prevValueLength = prevValueFormated.length

  let isErase = prevValueLength > currentValueLength
  
  if ((caret === 6) && !isErase) {
    setCursorPosition(element, caret + 1)
    return
  }

  setCursorPosition(element, caret)
}